import React, { useState } from 'react';

import { withCapacitor } from 'Util/Capacitors/hoc';
import { useGetFeedbackTemplate, useGiveFeedback, COMPONENT_TYPES } from 'Util/FeedBackService';
import { FeedbackReportModal } from 'Components/Feedback';

import { REPORT_STATE } from './constant';

const AppFeedbackReport = ({ user, toggleComponent, capacitorContext: { deviceInfo } }) => {
  const {
    data: templateData,
    loading,
    isSuccess: isGetTemplateSuccess,
  } = useGetFeedbackTemplate({
    templateId: 'APP_REPORT_FEEDBACK',
  });

  const [reportState, setReportState] = useState(REPORT_STATE.INITIALIZED);

  const { giveFeedback, loading: isGiveFeedbackLoading } = useGiveFeedback({
    templateId: 'APP_REPORT_FEEDBACK',
    onCompleted: () => setReportState(REPORT_STATE.COMPLETED),
  });

  if (!isGetTemplateSuccess) return toggleComponent ?? null;

  let options = [];
  const inputComponents = templateData?.getTemplate?.components;

  if (Array.isArray(inputComponents) && inputComponents.length) {
    const selectionComponent = inputComponents.find(
      (component) => component.type === COMPONENT_TYPES.CHOICE
    );
    options =
      selectionComponent?.options?.map((option) => ({
        label: option.title,
        value: option.value,
        disabled: option.value === null ? true : false,
      })) ?? [];
  }
  const userId = user?.id;
  const provider = user?.provider;
  return (
    <FeedbackReportModal
      toggleComponent={toggleComponent}
      onOpenModal={() => setReportState(REPORT_STATE.FILLING_FORM)}
      onCloseModal={() => setReportState(REPORT_STATE.INITIALIZED)}
      options={options}
      loading={loading || isGiveFeedbackLoading}
      isSuccess={reportState === REPORT_STATE.COMPLETED}
      onSubmit={(formValue) => {
        giveFeedback(provider, userId, deviceInfo, 'APP_REPORT_FEEDBACK', formValue);
      }}
    />
  );
};

export default withCapacitor(AppFeedbackReport);
